import { inject, injectable } from 'inversify';
import { ClientGameDependencyTypes } from '@client/entity/client-game/client-game.dependency-types';
import type { ClientGameRepositoryInterface } from '@client/entity/client-game/domain/repository/client-game.repository';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import { MissingSelectedClientForClientGamesReloadError } from '@client/entity/current-client-user/domain/error/missing-selected-client-for-client-games-reload.error';
import type { CurrentClientUserStoreCommand } from '@client/entity/current-client-user/domain/store/current-client-user.store-command';
import type { CurrentClientUserStoreQuery } from '@client/entity/current-client-user/domain/store/current-client-user.store-query';

@injectable()
export class CurrentClientUserSelectedClientGamesReloaderService {
  public constructor(
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserStoreQuery)
    private readonly currentClientUserStoreQuery: CurrentClientUserStoreQuery,
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserStoreCommand)
    private readonly currentClientUserStoreCommand: CurrentClientUserStoreCommand,
    @inject(ClientGameDependencyTypes.ClientGameRepository)
    private readonly clientGameRepository: ClientGameRepositoryInterface,
  ) {}

  public async reload(): Promise<void> {
    const selectedClient = this.currentClientUserStoreQuery.getSelectedClient();

    if (!selectedClient) {
      throw new MissingSelectedClientForClientGamesReloadError();
    }

    selectedClient.setGames(await this.clientGameRepository.fetchClientGames(selectedClient.id));
    this.currentClientUserStoreCommand.setSelectedClient(selectedClient);
  }
}
